import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  output,
} from '@angular/core';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'booking-type',
  templateUrl: './booking-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class BookingTypeComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output(); // {type:actionName,columnData }

  constructor() {}

  ngOnInit(): void {}
}
